/* ================================================================
   MIORAH — CART: FREE SHIPPING BAR, TRUST BLOCK, WHATSAPP FLOAT
   ================================================================
   The audit of 1 Oct found the cart was the quietest page on the
   site: item, total, checkout button, nothing else. No free-shipping
   nudge, no cash on delivery, no delivery estimate, no returns line,
   no WhatsApp. Every one of those sentences already existed on the
   product page and was dropped at the moment of commitment.

   This injects them above the checkout button on BOTH /cart and the
   drawer, and adds the WhatsApp float the storefront never had.

   WHY JAVASCRIPT: the Liquid home would be sections/main-cart-footer
   and snippets/cart-drawer, two core Dawn files that render the
   checkout button. A slip in either breaks checkout - the one page
   where a mistake costs an order rather than a click. Injecting
   means a failure loses a reassurance, not a function.

   ================================================================
   >>> I CHANGED THE AUDIT'S COPY, AND THE REASON MATTERS <<<
   ================================================================
   The audit proposed:

       "You're Rs 150 away from free delivery - add one more teddy
        and shipping is on us... At Rs 1,349 they pay Rs 1,499
        regardless. This is the rare upsell where the customer is
        strictly better off."

   That arithmetic assumes a Rs 150 product exists to add. It does
   not. Checked against the live catalogue on 2 Oct:

       1 Teddy          Rs 549
       Gift wrapping    Rs 300
       next bundle up   Rs 1,999

   The cheapest thing in the shop is Rs 300. So a customer sitting at
   Rs 1,349 cannot reach Rs 1,499 by spending Rs 150 - the smallest
   step available costs Rs 300 and saves Rs 150 of shipping, leaving
   them Rs 150 worse off, not level.

   Telling them "you pay the same either way" would therefore be
   FALSE, and false in the direction that gets noticed at the totals
   line one screen later. On a store whose entire problem is that
   nobody has vouched for it yet, being caught overstating a saving
   is expensive.

   So the bar states the gap honestly - "Rs 150 away from free
   delivery" - and the one-tap add is offered as what it actually is:
   gift wrapping for Rs 300, which crosses the threshold and is a
   genuinely relevant add for a gift purchase. The customer can do
   the sum themselves, and it still works as a nudge, because Rs 300
   of gift box for a net Rs 150 is a fair offer. It just is not free.

   If a Rs 150-200 product is ever added - a single mini soap, a card
   - revisit this: the audit's framing becomes true and much stronger.

   ================================================================
   THE THRESHOLD IS Rs 1,499 AND IS WRITTEN IN FIVE PLACES
   ================================================================
   Here, the announcement bar, the homepage FAQ, the shipping policy
   and Settings > Shipping. Only the last one charges the customer.
   Change them together.

   WHY A MutationObserver: Dawn re-renders the cart footer wholesale
   on every quantity change, so anything injected once on load is
   gone by the second interaction. Debounced with rAF, and the
   data-attribute guards make insertion idempotent - without them the
   observer reacts to its own work and loops.
   ================================================================ */
(function () {
  'use strict';

  var FREE_SHIP = 149900;                 /* Rs 1,499 in paise */
  var WRAP_VARIANT = 52238023164200;      /* Special Box + Gift Wrapping + Card, Rs 300 */
  var WRAP_PRICE = 30000;
  var WA = '923180727285';                /* 0318-0727285 */
  var MARK = 'data-mio-cart';
  var WAMARK = 'data-mio-wa';

  var ICONS = {
    wallet: '<path d="M3 7h14a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M3 7V6a2 2 0 012-2h9"/><path d="M16 12h.01"/>',
    truck:  '<path d="M3 6h10v9H3z"/><path d="M13 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="16" cy="18" r="1.6"/>',
    clock:  '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 1.8"/>',
    back:   '<path d="M3 10h11a5 5 0 010 10h-4"/><path d="M6.5 6.5L3 10l3.5 3.5"/>'
  };

  function rs(paise) {
    return 'Rs ' + Math.ceil(paise / 100).toLocaleString('en-US');
  }

  function svg(d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"' +
           ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }

  /* ---------------- the free shipping bar ---------------- */

  function buildShip(cart) {
    var total = cart.total_price || 0;
    var free = total >= FREE_SHIP;
    var gap = FREE_SHIP - total;

    var el = document.createElement('div');
    el.className = 'mio-ship' + (free ? ' is-free' : '');

    var note = free
      ? 'Free delivery applied to this order.'
      : 'You are <strong>' + rs(gap) + '</strong> away from free delivery.';

    var html = '<p class="mio-ship__note">' + note + '</p>' +
               '<div class="mio-ship__track"><span class="mio-ship__fill"></span></div>';

    /* Offer the gift wrap only when it actually crosses the threshold.
       Below that it is just an unrelated upsell and does not belong in
       a shipping message. */
    if (!free && gap <= WRAP_PRICE) {
      html += '<button type="button" class="mio-ship__add" data-mio-add>' +
              'Add gift wrapping &amp; card — Rs 300</button>';
    }

    el.innerHTML = html;

    var fill = el.querySelector('.mio-ship__fill');
    fill.style.transform = 'scaleX(' + Math.min(1, total / FREE_SHIP).toFixed(4) + ')';

    var add = el.querySelector('[data-mio-add]');
    if (add) {
      add.addEventListener('click', function () {
        add.disabled = true;
        add.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: WRAP_VARIANT, quantity: 1 }] })
        }).then(function () { window.location.reload(); })
          .catch(function () {
            add.disabled = false;
            add.textContent = 'Add gift wrapping & card — Rs 300';
          });
      });
    }

    return el;
  }

  /* ---------------- the trust block ----------------
     Four lines and a WhatsApp line. Deliberately short: this sits in
     a cart footer above the totals, and a reassurance that pushes the
     basket off screen is not reassuring.

     The free-delivery line is CONDITIONAL. It confirms free delivery
     only once the cart qualifies; below that the bar above already
     states the gap, and saying both would be the same fact twice. */

  function buildTrust(cart) {
    var free = (cart.total_price || 0) >= FREE_SHIP;

    var items = [
      [ICONS.wallet, 'Cash on delivery available across Pakistan'],
      [ICONS.clock,  'Delivered in 2–5 working days'],
      [ICONS.back,   '7 days to return unopened items']
    ];

    if (free) {
      items.splice(1, 0, [ICONS.truck, 'Free delivery on this order']);
    }

    var ul = document.createElement('ul');
    ul.className = 'mio-trust';

    var html = '';
    for (var i = 0; i < items.length; i++) {
      html += '<li>' + svg(items[i][0]) + '<span>' + items[i][1] + '</span></li>';
    }
    html += '<li>' + svg(ICONS.wallet).replace('stroke-width="1.8"', 'stroke-width="0" style="opacity:0"') +
            '<span>Questions before you order? ' +
            '<a href="https://wa.me/' + WA + '" target="_blank" rel="noopener">Message us on WhatsApp</a></span></li>';

    ul.innerHTML = html;
    return ul;
  }

  /* ---------------- insertion ---------------- */

  var SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#checkout',
    '.cart__checkout-button'
  ];

  function findButtons() {
    var out = [];
    for (var i = 0; i < SELECTORS.length; i++) {
      var n = document.querySelectorAll(SELECTORS[i]);
      for (var j = 0; j < n.length; j++) if (out.indexOf(n[j]) === -1) out.push(n[j]);
    }
    return out;
  }

  function anchorFor(btn) {
    return btn.closest('.cart__ctas, .cart-drawer__footer, .cart__blocks') || btn;
  }

  function apply(cart) {
    if (!cart) return;
    var buttons = findButtons();
    for (var i = 0; i < buttons.length; i++) {
      var anchor = anchorFor(buttons[i]);
      var parent = anchor.parentElement;
      if (!parent) continue;

      var existing = parent.querySelector(':scope > [' + MARK + ']');
      if (existing) existing.remove();

      if (!cart.item_count) continue;

      var wrap = document.createElement('div');
      wrap.setAttribute(MARK, '');
      wrap.appendChild(buildShip(cart));
      wrap.appendChild(buildTrust(cart));
      parent.insertBefore(wrap, anchor);
    }
  }

  /* ---------------- WhatsApp float ----------------
     Site-wide, not cart-only. The number was on the contact page and
     nowhere else, which on a store asking for cash on delivery is the
     single cheapest trust signal available. */

  function waFloat() {
    if (document.querySelector('[' + WAMARK + ']')) return;
    var a = document.createElement('a');
    a.className = 'mio-wa';
    a.setAttribute(WAMARK, '');
    a.href = 'https://wa.me/' + WA;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Message MIORAH on WhatsApp');
    a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 00-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1012 2zm0 18a8 8 0 01-4.1-1.1l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 1112 20zm4.4-5.8c-.2-.1-1.4-.7-1.6-.8s-.4-.1-.5.1-.6.8-.7.9-.3.2-.5 0a6.6 6.6 0 01-1.9-1.2 7.3 7.3 0 01-1.4-1.7c-.1-.2 0-.4.1-.5l.4-.4.2-.4v-.4l-.7-1.7c-.2-.4-.4-.4-.5-.4h-.5a1 1 0 00-.7.3 3 3 0 00-.9 2.2 5.2 5.2 0 001.1 2.7 11.9 11.9 0 004.6 4 5.3 5.3 0 002.4.5 2.7 2.7 0 001.8-1.3 2.2 2.2 0 00.2-1.3c-.1-.1-.2-.2-.4-.3z"/></svg>';
    document.body.appendChild(a);
  }

  /* ---------------- lifecycle ---------------- */

  var busy = false;
  function sync() {
    if (busy || !findButtons().length) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(apply)
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  function start() {
    waFloat();
    sync();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();